import { ArrowLeftIcon, PhotoIcon, UserCircleIcon, ArrowUpTrayIcon } from '@heroicons/react/20/solid'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import L from 'leaflet'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import { useState, useEffect } from 'react'
import { useLazyQuery, useMutation } from '@apollo/client'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { ErrorDialog, SuccessDialog } from 'components/custom/ResponseDialog'
import { PhoneInput } from 'react-international-phone'
import 'react-international-phone/style.css'
import { PhoneNumberUtil } from 'google-libphonenumber'
import { GET_LUGGAGE_MASTER_PLAN } from 'graphql/luggageMaster/queries'
import { CREATE_LUGGAGE_PLAN, UPDATE_LUGGAGE_PLAN } from 'graphql/luggageMaster/mutations'
import { Switch } from 'components'

export default function LuggageForm() {
    const bahrainCoordinates = [26.0667, 50.5577]
    const { id } = useParams()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [showSucDialog, setShowSucDialog] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [submitLoading, setSubmitLoading] = useState(false)
    const [luggageInfo, setLuggageInfo] = useState(null)

    const seatOptions = [
        { value: 'STD', description: 'Standard' },
        { value: 'VIP', description: 'VIP' },
    ]

    const luggageOptions = [
        { value: 'Default', description: 'Default' },
        { value: 'AddOn', description: 'AddOn' },
    ]

    const categoryOptions = [
        { value: 'checkIn', description: 'CheckIn' },
        { value: 'cabin', description: 'Cabin' },
    ]

    const handleBack = () => {
        navigate('/luggages')
    }
    const handleDialogClose = () => {
        setShowSucDialog(false)
        setShowErrDialog(false)
    }

    const [getLuggageById, { loading: luggageListLoading, error: luggageListError }] = useLazyQuery(
        GET_LUGGAGE_MASTER_PLAN,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.searchLuggage.success && data.searchLuggage.code === '200') {
                    setLuggageInfo(data.searchLuggage.luggages[0])
                }
            },
        }
    )

    useEffect(() => {
        if (id) {
            getLuggageById({
                variables: {
                    page: {
                        limit: 1,
                        offset: 0,
                    },
                    search_string: null,
                    id: id,
                    status_code: null,
                },
            })
        }
    }, [id])

    //  MUtation Add Luggage
    const [addNewLuggage, { loading: addLoading }] = useMutation(CREATE_LUGGAGE_PLAN, {
        onCompleted: data => {
            if (data?.addLuggage.code === '200' && data?.addLuggage.success === true) {
                CreateLuggageFormValidation.setSubmitting(false)
                setSubmitLoading(false)
                setShowSucDialog(true)
                // Time delay to redirect to the users page
                setTimeout(() => {
                    handleBack()
                }, 500)
            } else {
                CreateLuggageFormValidation.setSubmitting(false)
                setSubmitLoading(false)
                setErrorMessage(data?.addBoat.message)
                setShowErrDialog(true)
            }
        },
        onError: error => {
            setSubmitLoading(false)
            CreateLuggageFormValidation.setSubmitting(false)
            setErrorMessage(error.message)
            setShowErrDialog(true)
        },
    })
    // Mutation Update Boat
    const [updateLuggage, { loading: updateLoading }] = useMutation(UPDATE_LUGGAGE_PLAN, {
        onCompleted: data => {
            if (data?.updateLuggage.code === '200' && data?.updateLuggage.success === true) {
                CreateLuggageFormValidation.setSubmitting(false)
                setSubmitLoading(false)
                setShowSucDialog(true)
                // Time delay to redirect to the users page
                setTimeout(() => {
                    handleBack()
                }, 500)
            } else {
                CreateLuggageFormValidation.setSubmitting(false)
                setSubmitLoading(false)
                setErrorMessage(data?.updateBoat.message)
                setShowErrDialog(true)
            }
        },
        onError: error => {
            setSubmitLoading(false)
            CreateLuggageFormValidation.setSubmitting(false)
            setErrorMessage(error.message)
            setShowErrDialog(true)
        },
    })
    // Form Validation
    const CreateLuggageFormValidation = useFormik({
        enableReinitialize: true,
        initialValues: {
            luggage_id: luggageInfo?.luggage_id || '',
            luggage_type: luggageInfo?.metadata?.luggage_type || '',
            weight: luggageInfo?.weight || '',
            seat_type: luggageInfo?.metadata?.seat_type || '',
            height: luggageInfo?.dimensions?.height || '',
            width: luggageInfo?.dimensions?.width || '',
            length: luggageInfo?.dimensions?.length || '',
            piece_count: luggageInfo?.metadata?.piece_count || '',
            category: luggageInfo?.metadata?.category || '',
            active: luggageInfo?.active || false,
            price: luggageInfo?.price?.base || '',
            luggage_id: luggageInfo?.luggage_id,
        },
        validationSchema: Yup.object().shape({
            luggage_type: Yup.string().required('Luggage name is required'),
            seat_type: Yup.string().required('Seat type is required'),
            weight: Yup.string()
                .required('Weight is required')
                .matches(/^\d{1,3}$/, 'Weight must be 1 to 3 digits only (max 999)'),
            height: Yup.string().required('Heigth is required'),
            width: Yup.string().required('Width is required'),
            length: Yup.string().required('Length is required'),
            price: Yup.string().required('Price is required'),
            piece_count: Yup.string().required('piece count is required'),
            category: Yup.string().required('category is required'),
        }),
        onSubmit: values => {
            setSubmitLoading(true)
            submitLuggage(values)
        },
    })
    // Submit Luggage
    const submitLuggage = values => {
        const formattedData = {
            luggage: {
                weight: Number(values.weight),
                dimensions: {
                    width: Number(values.width),
                    length: Number(values.length),
                    height: Number(values.height),
                },
                price: {
                    base: Number(values.price),
                },
                active: values.active,
                metadata: {
                    luggage_type: values.luggage_type,
                    seat_type: values.seat_type,
                    category: values.category,
                    piece_count: Number(values.piece_count),
                },
            },
            luggage_id: values.luggage_id,
        }

        if (id) {
            formattedData.luggage_id = id
            updateLuggage({
                variables: formattedData,
            })
        } else {
            addNewLuggage({
                variables: formattedData,
            })
        }
    }

    useEffect(() => {
        const { luggage_type, price } = CreateLuggageFormValidation.values

        if (luggage_type === 'Default' && price !== 0) {
            CreateLuggageFormValidation.setFieldValue('price', 0)
        }
        if (luggage_type !== 'Default' && price === 0) {
            CreateLuggageFormValidation.setFieldValue('price', '')
        }
    }, [CreateLuggageFormValidation.values.luggage_type])

    const handlePositiveNumberChange = formik => e => {
        const { name, value } = e.target

        if (value === '') {
            formik.setFieldValue(name, '')
            return
        }

        if (/^\d+$/.test(value)) {
            formik.setFieldValue(name, value)
        }
    }

    const handleWeightChange = formik => e => {
        const { name, value } = e.target

        if (value === '') {
            formik.setFieldValue(name, '')
            return
        }

        if (/^\d{1,3}$/.test(value)) {
            formik.setFieldValue(name, value)
            formik.setFieldError(name, '')
            return
        }

        if (/^\d+$/.test(value) && value.length > 3) {
            formik.setFieldTouched(name, true, false)
            formik.setFieldError(name, 'Weight must be 1 to 3 digits only (max 999)')
        }
    }

    return (
        <>
            <div className="mb-8 flex justify-between items-center">
                <button
                    type="button"
                    onClick={handleBack}
                    className="inline-flex items-center gap-x-0.5 rounded-md text-sm"
                >
                    <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 h-5 w-5 rtl:rotate-180" />
                    {t('Back')}
                </button>
                <div className="flex gap-3">
                    <button
                        type="button"
                        onClick={handleBack}
                        className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                        {t('Cancel')}
                    </button>
                    <button
                        disabled={CreateLuggageFormValidation.isSubmitting}
                        onClick={CreateLuggageFormValidation.handleSubmit}
                        type="button"
                        className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    >
                        {t('Save')}
                    </button>
                </div>
            </div>
            <form>
                <div className="space-y-6">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-5 md:grid-cols-3">
                        <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">{t('Seat Type')}</h2>
                            <p className="mt-1 text-sm leading-6 text-gray-600">
                                {t(' Select the seat type Standard-Vip')}
                            </p>
                        </div>

                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
                            <div className="sm:col-span-6">
                                <label
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {t('Seat Type')}
                                    <span className="text-red">*</span>
                                </label>
                                <div className="mt-2">
                                    <select
                                        id="seat_type"
                                        name="seat_type"
                                        type="text"
                                        value={CreateLuggageFormValidation.values.seat_type}
                                        onChange={CreateLuggageFormValidation.handleChange}
                                        onBlur={CreateLuggageFormValidation.handleBlur}
                                        placeholder="Enter here"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    >
                                        <option value="">{t('Select Seat')}</option>
                                        {seatOptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.description}
                                            </option>
                                        ))}
                                    </select>
                                    {CreateLuggageFormValidation.touched.weight &&
                                        CreateLuggageFormValidation.errors.weight && (
                                            <p className="text-error text-xs mt-1">
                                                {CreateLuggageFormValidation.errors.weight}
                                            </p>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-4 border-b border-gray-900/10 pb-5 md:grid-cols-3">
                        <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">{t('Luggage Category')}</h2>
                            <p className="mt-1 text-sm leading-6 text-gray-600">
                                {t(' Precise Category and number of luggages for the trip.')}
                            </p>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
                            <div className="sm:col-span-3">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                    {t('Category ')}
                                    <span className="text-red">*</span>
                                </label>
                                <div className="mt-2">
                                    <select
                                        id="category"
                                        name="category"
                                        type="text"
                                        value={CreateLuggageFormValidation.values.category}
                                        onChange={CreateLuggageFormValidation.handleChange}
                                        onBlur={CreateLuggageFormValidation.handleBlur}
                                        placeholder="Enter here"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    >
                                        <option value="">{t('Select Category')}</option>
                                        {categoryOptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.description}
                                            </option>
                                        ))}
                                    </select>
                                    {CreateLuggageFormValidation.touched.category &&
                                        CreateLuggageFormValidation.errors.category && (
                                            <p className="text-error text-xs mt-1">
                                                {CreateLuggageFormValidation.errors.category}
                                            </p>
                                        )}
                                </div>
                            </div>
                            <div className="sm:col-span-3">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                    {t('Piece Count')}
                                    <span className="text-red">*</span>
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="piece_count"
                                        name="piece_count"
                                        type="text"
                                        value={CreateLuggageFormValidation.values.piece_count}
                                        onChange={handlePositiveNumberChange(CreateLuggageFormValidation)}
                                        onBlur={CreateLuggageFormValidation.handleBlur}
                                        placeholder="Enter here"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    />
                                    {CreateLuggageFormValidation.touched.piece_count &&
                                        CreateLuggageFormValidation.errors.piece_count && (
                                            <p className="text-error text-xs mt-1">
                                                {CreateLuggageFormValidation.errors.piece_count}
                                            </p>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-4 border-b border-gray-900/10 pb-5 md:grid-cols-3">
                        <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                                {t('Luggage Information')}
                            </h2>
                            <p className="mt-1 text-sm leading-6 text-gray-600">
                                {t(' Detailed Information, including dimensions, type and price')}
                            </p>
                        </div>

                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
                            <div className="sm:col-span-6">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                    {t('Luggage Type')}
                                    <span className="text-red">*</span>
                                </label>
                                <div className="mt-2">
                                    <select
                                        id="luggage_type"
                                        name="luggage_type"
                                        value={CreateLuggageFormValidation.values.luggage_type}
                                        onChange={CreateLuggageFormValidation.handleChange}
                                        onBlur={CreateLuggageFormValidation.handleBlur}
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    >
                                        <option value="">{t('Select Luggage')}</option>
                                        {luggageOptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.description}
                                            </option>
                                        ))}
                                    </select>
                                    {CreateLuggageFormValidation.touched.luggage_type &&
                                        CreateLuggageFormValidation.errors.luggage_type && (
                                            <p className="text-error text-xs mt-1">
                                                {CreateLuggageFormValidation.errors.luggage_type}
                                            </p>
                                        )}
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <label
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                    {t('Height')}
                                    <span className="text-red">*</span>
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="height"
                                        name="height"
                                        type="text"
                                        value={CreateLuggageFormValidation.values.height}
                                        onChange={handlePositiveNumberChange(CreateLuggageFormValidation)}
                                        onBlur={CreateLuggageFormValidation.handleBlur}
                                        placeholder="Enter here"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    />
                                    {CreateLuggageFormValidation.touched.height &&
                                        CreateLuggageFormValidation.errors.height && (
                                            <p className="text-error text-xs mt-1">
                                                {CreateLuggageFormValidation.errors.height}
                                            </p>
                                        )}
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                    {t('Width')}
                                    <span className="text-red">*</span>
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="width"
                                        name="width"
                                        type="text"
                                        value={CreateLuggageFormValidation.values.width}
                                        onChange={handlePositiveNumberChange(CreateLuggageFormValidation)}
                                        onBlur={CreateLuggageFormValidation.handleBlur}
                                        placeholder="Enter here"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    />
                                    {CreateLuggageFormValidation.touched.width &&
                                        CreateLuggageFormValidation.errors.width && (
                                            <p className="text-error text-xs mt-1">
                                                {CreateLuggageFormValidation.errors.width}
                                            </p>
                                        )}
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                    {t('Length')}
                                    <span className="text-red">*</span>
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="length"
                                        name="length"
                                        type="text"
                                        value={CreateLuggageFormValidation.values.length}
                                        onChange={handlePositiveNumberChange(CreateLuggageFormValidation)}
                                        onBlur={CreateLuggageFormValidation.handleBlur}
                                        placeholder="Enter here"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    />
                                    {CreateLuggageFormValidation.touched.length &&
                                        CreateLuggageFormValidation.errors.length && (
                                            <p className="text-error text-xs mt-1">
                                                {CreateLuggageFormValidation.errors.length}
                                            </p>
                                        )}
                                </div>
                            </div>
                            <div className="sm:col-span-3">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                    {t('Weight')}
                                    <span className="text-red">*</span>
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="weight"
                                        name="weight"
                                        type="text"
                                        maxLength={3}
                                        value={CreateLuggageFormValidation.values.weight}
                                        onChange={handleWeightChange(CreateLuggageFormValidation)}
                                        onBlur={CreateLuggageFormValidation.handleBlur}
                                        placeholder="Enter here"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    />
                                    {CreateLuggageFormValidation.touched.weight &&
                                        CreateLuggageFormValidation.errors.weight && (
                                            <p className="text-error text-xs mt-1">
                                                {CreateLuggageFormValidation.errors.weight}
                                            </p>
                                        )}
                                </div>
                            </div>
                            <div className="sm:col-span-3">
                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                    {t('Price')}
                                    <span className="text-red">*</span>
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="price"
                                        name="price"
                                        type="text"
                                        value={CreateLuggageFormValidation.values.price}
                                        onChange={handlePositiveNumberChange(CreateLuggageFormValidation)}
                                        disabled={CreateLuggageFormValidation.values.luggage_type === 'Default'}
                                        onBlur={CreateLuggageFormValidation.handleBlur}
                                        placeholder="Enter here"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                    />
                                    {CreateLuggageFormValidation.touched.price &&
                                        CreateLuggageFormValidation.errors.price && (
                                            <p className="text-error text-xs mt-1">
                                                {CreateLuggageFormValidation.errors.price}
                                            </p>
                                        )}
                                </div>
                            </div>
                            <div className="sm:col-span-6">
                                <div className="flex items-center">
                                    <Switch
                                        checked={Boolean(CreateLuggageFormValidation.values.active)}
                                        onChange={checked =>
                                            CreateLuggageFormValidation.setFieldValue('active', checked)
                                        }
                                    />
                                    <label className="ml-3 block text-sm font-medium leading-6 text-gray-900">
                                        {t('Active')}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-6 flex items-center justify-end gap-x-3">
                    <button
                        onClick={handleBack}
                        type="button"
                        className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                        {t('Cancel')}
                    </button>
                    <button
                        disabled={CreateLuggageFormValidation.isSubmitting}
                        type="submit"
                        onClick={CreateLuggageFormValidation.handleSubmit}
                        className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    >
                        {t('Save')}
                    </button>
                </div>
            </form>
            {showErrDialog && (
                <ErrorDialog status={true} title="Error" message={errorMessage} onClose={handleDialogClose} />
            )}
            {showSucDialog && (
                <SuccessDialog
                    status={true}
                    title={t('Success')}
                    message={t('Saved Successfully')}
                    onClose={handleDialogClose}
                />
            )}
            {/* Overlay and Loading Spinner */}
            {submitLoading && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
                </div>
            )}
        </>
    )
}
